<template>
    <b-card>
       <div class="card-header">
           <h5 class="card-title mb-0"><b>{{ $t('confirmation') }}</b></h5>
       </div>
       <div class="card-body">
           <div class="mb-3">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-success rounded-circle fs-16 text-white`" >
                           <i :class="`bx bxs-user`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('Manager') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content">
                               <h6 :class="`text-truncate mb-0 fs-14 `" > {{ this.form.workerName }}</h6>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <div class="mb-3">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-success rounded-circle fs-16 text-white`" >
                           <i :class="`bx bx-time`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('executionDateTime') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content">
                                <h6 :class="`text-truncate mb-0 fs-14 `" > {{ this.form.datetime }}</h6>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <div class="mb-3">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-success rounded-circle fs-16 text-white`" >
                           <i :class="`bx bx-comment`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('Comment') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content">
                                <h6 :class="`text-truncate mb-0 fs-14 `" style="word-break: auto-phrase; white-space: unset"> {{ this.form.comment }}</h6>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </b-card>
</template>

<script>

export default{
   props: ['obj'],
   data(){
       return {
           form: ''
       }
   },
   created(){
       this.form = this.obj
   },
   methods: {
   }
}
</script>